import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import PriceBoostMarketContentImpl from './price-boost-market-content.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays market lines with boosted selection prices.
 *
 * @class PriceBoostMarketContent
 * @memberof Mojito.Modules.AggregatedMarketPane
 */

/**
 * PriceBoostMarketContent prop types.
 *
 * @property {Mojito.Services.SportsContent.Events.types.AggregatedMarket} aggregatedMarket - Aggregated market object.
 * @property {object} eventItem - Event item object.
 *
 * @memberof Mojito.Modules.AggregatedMarketPane.PriceBoostMarketContent
 */
const propTypes = {
    aggregatedMarket: PropTypes.object.isRequired,
    eventItem: PropTypes.object.isRequired,
};

export default UIView('PriceBoostMarketContent', PriceBoostMarketContentImpl, propTypes);
